import { render, staticRenderFns } from "./AccommodationTypesCheckboxes.vue?vue&type=template&id=f539f0be&lang=pug&"
import script from "./AccommodationTypesCheckboxes.vue?vue&type=script&lang=js&"
export * from "./AccommodationTypesCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports